import { render, staticRenderFns } from "./common-tupu.vue?vue&type=template&id=4a8dc9d2&scoped=true&"
import script from "./common-tupu.vue?vue&type=script&lang=ts&"
export * from "./common-tupu.vue?vue&type=script&lang=ts&"
import style0 from "./common-tupu.vue?vue&type=style&index=0&id=4a8dc9d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8dc9d2",
  null
  
)

export default component.exports